import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  moreLink,
  moreText = '查看更多',
}: SectionHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow ? (
          <p className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
            {eyebrow}
          </p>
        ) : null}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {subtitle ? <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p> : null}
      </div>
      {moreLink ? (
        <Link
          to={moreLink}
          className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600"
        >
          {moreText}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      ) : null}
    </div>
  );
}